export enum Endpoint {

  POST_GERAR_LEITURA = '/beneficiary-service/resources/mensagens/:nrSeqBeneficiario/gerar-leitura',
  REQUISICOES_GUIAS = '/beneficiary-service/resources/beneficiarios/:nrSeqBeneficiario/requisicao-autorizacao/:nrSeqRequisicao/guias',
  GET_MENSAGENS = '/beneficiary-service/resources/mensagens/:nrSeqBeneficiario',
  GET_MENSAGEM_ANEXOS = '/beneficiary-service/resources/mensagens/:nrSeqBeneficiario/anexos',
  GET_REGRA_MENU_MENSALIDADE = '/beneficiary-service/resources/beneficiarios/:nrSeqBeneficiario/financeiro/mensalidades/:nrSeqMensalidade/regras/:nrSeqRegra',
  GET_MENU_DINAMICO = '/beneficiary-service/resources/dinamico/menu-option',
}